import React from "react";
import { Header } from "Components/DP/DPTable/DPTable";
import { DPTable, DPEmptyTable, DPComponentLoader } from "Components/DP";
import DirectDepositTableRow from "../DirectDepositTableRow/DirectDepositTableRow";
import { DPDirectDepositResponse } from "Shared/types/DirectDeposit";
import { usePartnerConfig } from "Hooks/usePartnerConfig";

const directDepositHeaders: Header[] = [
  "Date/Time",
  "Downloaded By",
  "File Name",
  "Submission",
];

type Props = {
  setPage: (page: number) => void;
  page: number;
  loading: boolean;
  rowsPerPage: number;
  directDepositUpdateFiles: DPDirectDepositResponse;
};

const DirectDepositTable = ({
  setPage,
  page,
  loading,
  rowsPerPage,
  directDepositUpdateFiles,
}: Props) => {
  const { permissions } = usePartnerConfig();

  const headers = permissions.canDownloadDirectDepositUpdates
    ? directDepositHeaders
    : directDepositHeaders.filter(h => h !== "Submission");

  const totalCount = directDepositUpdateFiles?.totalCount || 0;

  const onChangePageFn = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => {
    setPage(page);
  };

  return (
    <DPTable
      page={page}
      rowsPerPage={rowsPerPage}
      count={totalCount}
      headers={headers}
      onChangePage={onChangePageFn}
    >
      <DPComponentLoader
        isLoading={loading}
        kind={"table"}
        awaitComponent={
          directDepositUpdateFiles && directDepositUpdateFiles.items.length ? (
            <>
              {directDepositUpdateFiles.items.map(file => (
                <DirectDepositTableRow key={file.id} {...file} />
              ))}
            </>
          ) : (
            <DPEmptyTable message={"Downloads will appear here once created"} />
          )
        }
      />
    </DPTable>
  );
};

export default DirectDepositTable;
